








































import { Vue, Component } from "vue-property-decorator";

@Component
export default class WebFooter extends Vue {
  currentFullYear = new Date().getFullYear();
}
